// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.account .col-md-12.col-sm-12 .info .form-group {
  width: 15%;
}

.account .col-md-12.col-sm-12 .info .modal-body .form-group {
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./apps/lms/src/css/account/account.css"],"names":[],"mappings":"AAAA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb","sourcesContent":[".account .col-md-12.col-sm-12 .info .form-group {\n  width: 15%;\n}\n\n.account .col-md-12.col-sm-12 .info .modal-body .form-group {\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
